import React, {
  useEffect,
  useState,
} from 'react';
import {
  Button, ButtonGroup, Card, Checkbox, Collapse, Grid, List, ListItem, ListItemIcon, ListItemText, Alert,
} from '@mui/material';
import LogicaPing from '../Ping';
import { DimmableLoader, Modal } from '../../../components/Styled/Misc';
import LoginInLogica from '../loginInLogica/editor';
import { CloseButton } from '../../../components/Styled/Buttons';
import EditorControls from '../../BaseEditor/editorControls';
import useSTAFiles from './hook';

function Editor() {
  const [logicaPingSuccess, setLogicaPingSuccess] = useState(true);
  const [modalLogicaLogin, setModalLogicaLogin] = useState(false);
  const {
    ticket,
    loading,
    err,
    done,
    year,
    setYear,
    dates,
    onLoadDates,
    onCheckDate,
    onLoadWithParams,
    onQuickLoad,
    canOrg,
    org, setOrg,

  } = useSTAFiles();
  useEffect(
    () => {
      if (!ticket) {
        setModalLogicaLogin(true);
      }
    },
    [ticket],
  );

  const countToLoad = dates.filter((d) => d.checked).length;

  return (
    <>
      <LogicaPing available={logicaPingSuccess} handleAvailable={setLogicaPingSuccess} />
      <DimmableLoader loading={loading}>
        <ButtonGroup variant="outlined">
          <Button
            variant="outlined"
            onClick={onQuickLoad}
            disabled={!logicaPingSuccess}
            color="primary"
          >
            Оновити все
          </Button>
          <Button
            onClick={onLoadDates}
            color="secondary"
            variant="outlined"
            disabled={!logicaPingSuccess}
          >
            Оновити з
            додатковими налаштуваннями
          </Button>
        </ButtonGroup>
        {err && (
          <Alert severity="error">{err}</Alert>
        )}
        {done && (
          <Alert severity="info">Дані завантажено вдало!</Alert>
        )}
        {canOrg && (
          <EditorControls.ItemPicker
            backend="/api/cat/org"
            value={org}
            onChange={(e, v) => setOrg(v)}
            label="Установа"
          />
        )}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EditorControls.NumerInput
              label="Рік"
              required
              value={year}
              onChange={(e, v) => {
                setYear(v);
              }}
            />
          </Grid>
        </Grid>
        <Collapse in={!!dates.length}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Card>
                <List
                  dense
                  disablePadding
                >
                  {dates.map(({
                    datefile,
                    label,
                    checked,
                  }) => (
                    <ListItem key={datefile}>
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          checked={checked}
                          onChange={(e, v) => onCheckDate(datefile, v)}
                        />
                      </ListItemIcon>
                      <ListItemText>
                        {label.toLocaleDateString('uk', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric',
                        })}
                      </ListItemText>
                    </ListItem>
                  ))}
                </List>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={onLoadWithParams}
                color="secondary"
                variant="outlined"
                disabled={!logicaPingSuccess || !countToLoad}
                style={{ width: '100%', height: '100%' }}
              >
                Завантажити
              </Button>
            </Grid>

          </Grid>
        </Collapse>
        <Modal open={modalLogicaLogin}>
          <>
            <h3>Авторизація в Логіці</h3>
            <LoginInLogica />
            <div style={{ width: '300px' }}>
              <CloseButton onClick={() => {
                setModalLogicaLogin(false);
              }}
              />
            </div>
          </>
        </Modal>

      </DimmableLoader>
    </>
  );
}
export default Editor;
